import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type CreatePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesPostData,
  type CreatePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesPostError,
  type CreatePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesPostResponse,
  createPdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesPost,
} from '../../generated';

export type CreatePdpImageMutationVariables = CreatePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesPostData['path'] &
  CreatePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesPostData['body'];

export type CreatePdpImageMutation = CreatePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesPostResponse;

export const useCreatePdpImageMutation = <
  TError = CreatePdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<CreatePdpImageMutation, TError, CreatePdpImageMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<CreatePdpImageMutation, TError, CreatePdpImageMutationVariables, TContext>({
    mutationKey: ['CreatePdpImage'],
    mutationFn: async ({ workspace_id, pdp_id, ...body }: CreatePdpImageMutationVariables) => {
      const { data } = await createPdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesPost({
        path: { workspace_id, pdp_id },
        body,
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useCreatePdpImageMutation.fetcher = (
  { workspace_id, pdp_id, ...body }: CreatePdpImageMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await createPdpImageV1WorkspacesWorkspaceIdPdpsPdpIdImagesPost({
      path: { workspace_id, pdp_id },
      body,
      throwOnError: true,
    });
    return data;
  };
};
